import React, {
  useState,
} from 'react';
import {
  CardElement,
  injectStripe,
} from 'react-stripe-elements';

import {
  Button,
} from 'web-components';

import * as S from './styled';

const createOptions = () => ({
  style: {
    base: {
      fontSize: '16px',
      color: '#424770',
      fontFamily: 'Open Sans, sans-serif',
      letterSpacing: '0.025em',
      '::placeholder': {
        color: '#aab7c4',
      },
    },
    invalid: {
      color: '#c23d4b',
    },
  },
});

interface Props {
  stripe: any,
  clientSecret: string,
  onSuccess: { (response: any): void },
}

const CardForm = ({
  stripe,
  clientSecret,
  onSuccess,
}: Props) => {
  const [card, setCard] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = ({ error }) => {
    if (error) {
      setErrorMessage(error.message);
    }
  };

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    setErrorMessage('');
    setLoading(true);
    if (stripe) {
      let res;
      if (clientSecret) {
        res = await stripe.confirmCardPayment(
          clientSecret,
          card,
        );
      } else {
        res = await stripe.createPaymentMethod(
          'card',
          card,
        );
      }

      console.log('CardForm response', res);
      if (res.error) {
        setErrorMessage(res.error.message);
      } else {
        onSuccess(res);
      }
      setLoading(false);
    } else {
      console.log("Stripe.js hasn't loaded yet.");
    }
  };

  return (
    <S.FormWrapper
      onSubmit={handleSubmit}
    >
      <label>
        Card details
        <CardElement
          id="el"
          onReady={el => setCard(el)}
          onChange={handleChange}
          {...createOptions()}
        />
      </label>
      <S.Error>
        {errorMessage}
      </S.Error>
      <Button
        type="submit"
        isLoading={isLoading}
        isDisabled={isLoading}
      >
        {clientSecret ? 'Pay' : 'Add'}
      </Button>
    </S.FormWrapper>
  );
};

export default injectStripe(CardForm);
